export const CARD_RULES: CardRules = {
  amex: {
    brand: 'amex',
    pattern: /^3[47]/,
    numberLength: 15,
    cvvLength: 4,
    mask: '#### ###### #####' // 4-6-5
  },
  diners: {
    brand: 'diners',
    pattern: /^3(?:0|6|8)/,
    numberLength: 14,
    cvvLength: 3,
    mask: '#### ###### ####' // 4-6-4
  },
  visa: {
    brand: 'visa',
    pattern: /^4/,
    numberLength: 19,
    cvvLength: 3,
    mask: '#### #### #### #### ###' // 4-4-4-4-3
  },
  mastercard: {
    brand: 'mastercard',
    pattern: /^(5[1-5]|2[2-7])/,
    numberLength: 19,
    cvvLength: 3,
    mask: '#### #### #### #### ###'
  },
  hipercard: {
    brand: 'hipercard',
    pattern: /^(606282|3841)/,
    numberLength: 19,
    cvvLength: 3,
    mask: '#### #### #### #### ###'
  },
  default: {
    brand: 'default',
    pattern: /.*/,
    numberLength: 16,
    cvvLength: 3,
    mask: '#### #### #### ####'
  }
}
